import React, { useEffect, useState } from 'react';
import { List, SidebarSimple, SignOut } from '@phosphor-icons/react';
import CareLogo from './CareLogo';

// Barra lateral do CareOS (.lateral), a mesma do hub: fixa à esquerda, recolhe
// para só ícones (lembra a escolha) e vira gaveta no celular. Estilo em
// styles/care-app.css. As seções do painel são estado (não rotas), então cada
// item é um botão que troca a seção.

const CHAVE_RECOLHIDA = 'gerencial.lateral.recolhida';

const ler = (chave) => {
  try { return localStorage.getItem(chave); } catch { return null; }
};
const gravar = (chave, valor) => {
  try { localStorage.setItem(chave, valor); } catch { /* sem armazenamento: só não lembra */ }
};

const iniciais = (email, nome) => {
  const base = (nome || email?.split('@')[0] || '').replace(/[._-]+/g, ' ').trim();
  const partes = base.split(/\s+/).filter(Boolean);
  if (partes.length === 0) return '?';
  if (partes.length === 1) return partes[0].slice(0, 2).toUpperCase();
  return (partes[0][0] + partes[partes.length - 1][0]).toUpperCase();
};

const BarraLateral = ({ grupos, ativo, onSelecionar, user, onSair }) => {
  const [recolhida, setRecolhida] = useState(() => ler(CHAVE_RECOLHIDA) === '1');
  const [gavetaAberta, setGavetaAberta] = useState(false);

  // Esc fecha a gaveta do celular.
  useEffect(() => {
    if (!gavetaAberta) return undefined;
    const fechar = (e) => { if (e.key === 'Escape') setGavetaAberta(false); };
    window.addEventListener('keydown', fechar);
    return () => window.removeEventListener('keydown', fechar);
  }, [gavetaAberta]);

  const alternarRecolhida = () => {
    setRecolhida((r) => { gravar(CHAVE_RECOLHIDA, r ? '0' : '1'); return !r; });
  };

  // Recolhida só vale no desktop; na gaveta do celular a barra vem inteira.
  const mostrarRecolhida = recolhida && !gavetaAberta;
  const itemAtivo = grupos.flatMap((g) => g.itens).find((i) => i.id === ativo);

  return (
    <>
      {/* Celular: barra do topo com o menu e o nome da seção */}
      <div className="app-topo print:hidden">
        <button
          type="button"
          className="app-topo__menu"
          onClick={() => setGavetaAberta(true)}
          aria-label="Abrir menu"
          aria-expanded={gavetaAberta}
        >
          <List size={24} aria-hidden="true" />
        </button>
        <span className="app-topo__titulo">{itemAtivo?.rotulo || 'Gerencial'}</span>
      </div>
      {gavetaAberta && <div className="app-cortina" onClick={() => setGavetaAberta(false)} aria-hidden="true" />}

      <nav
        className="lateral"
        aria-label="Seções do painel"
        data-recolhido={mostrarRecolhida ? '' : undefined}
        data-aberta={gavetaAberta ? '' : undefined}
      >
        <div className="lateral__topo">
          <span className="lateral__marca" title={mostrarRecolhida ? 'Gerencial' : undefined}>
            <CareLogo simbolo height={22} title="Care" />
            {!mostrarRecolhida && <span>Gerencial</span>}
          </span>
          {!mostrarRecolhida && (
            <button
              type="button"
              className="lateral__icone lateral__recolher"
              onClick={alternarRecolhida}
              aria-label="Recolher menu"
              title="Recolher menu"
            >
              <SidebarSimple size={20} aria-hidden="true" />
            </button>
          )}
        </div>
        {mostrarRecolhida && (
          <button
            type="button"
            className="lateral__icone"
            style={{ alignSelf: 'center', marginBottom: 12 }}
            onClick={alternarRecolhida}
            aria-label="Expandir menu"
            title="Expandir menu"
          >
            <SidebarSimple size={20} aria-hidden="true" />
          </button>
        )}

        <div className="lateral__rolagem">
          {grupos.map((g) => (
            <div key={g.titulo} className="lateral__grupo">
              <div className="lateral__grupo-titulo">{g.titulo}</div>
              {g.itens.map(({ id, rotulo, Icone }) => {
                const aceso = id === ativo;
                return (
                  <div key={id} className="lateral__linha">
                    <button
                      type="button"
                      className="lateral__item"
                      aria-current={aceso ? 'page' : undefined}
                      title={mostrarRecolhida ? rotulo : undefined}
                      aria-label={mostrarRecolhida ? rotulo : undefined}
                      onClick={() => { onSelecionar(id); setGavetaAberta(false); }}
                    >
                      <span className="lateral__item-icone">
                        <Icone size={20} weight={aceso ? 'fill' : 'regular'} aria-hidden="true" />
                      </span>
                      <span className="lateral__item-rotulo">{rotulo}</span>
                    </button>
                  </div>
                );
              })}
            </div>
          ))}
        </div>

        <div className="lateral__pe">
          <span className="lateral__eu" title={user?.email || undefined}>{iniciais(user?.email, user?.name)}</span>
          <span className="lateral__email lateral__texto" title={user?.email || undefined}>
            {user?.name || user?.email}
          </span>
          <button
            type="button"
            onClick={onSair}
            className="lateral__icone"
            aria-label="Sair"
            title="Sair"
          >
            <SignOut size={18} aria-hidden="true" />
          </button>
        </div>
      </nav>
    </>
  );
};

export default BarraLateral;
